<template> 
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold">پرینت حواله بین انبار</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div class="row d-flex justify-content-center">
                    <div class="col-7">
                        <div class="d-flex justify-content-between">  
                            <h4>حواله بین انبار از  <span class="font-bold">{{ parsedVarieties[0].from_store_name }}</span> به 
                                <span class="font-bold" v-text="parsedVarieties[0].to_store_name"></span>
                                توسط  <span class="font-bold">{{  parsedVarieties[0].seller_name }}</span>
                            </h4>  
                            <h4>تاریخ: <span v-text="parsedVarieties[0].created_at"></span></h4>  
                        </div>  
                    </div>  
                    <table class="table table-responsive-sm table-bordered table-hover">
                        <thead>  
                            <tr>  
                                <th>ردیف</th>  
                                <th>محصول</th>  
                                <th>تنوع</th>  
                                <th>تعداد مرکزی</th>  
                                <th>مقدار انتقال</th>  
                                <th>وضعیت</th>  
                            </tr>  
                        </thead>  
                        <tbody>  
                            <tr v-for="(variety, index) in parsedVarieties" :key="index">  
                                <td>{{ index + 1 }}</td>  
                                <td>{{ variety.product_title }}</td>  
                                <td>{{ variety.title }}</td>  
                                <td>{{ variety.quantity }}</td>  
                                <td>{{ variety.agencyQuantity || 0 }}</td>  
                                <td></td>
                            </tr>  
                        </tbody>  
                    </table>  
                </div>  
            </div>  
            <div class="card-footer d-print-none" v-if="varieties.length > 0">
                <div class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-purple" onclick="window.print()">چاپ</button>
                </div>
            </div>  
        </div>  
    </main>
</template>  

<script>  
export default {  
    props: {  
        varieties: {  
            type: String,  
            required: true  
        }  
    },  
    computed: {  
        parsedVarieties() {  
            return JSON.parse(this.varieties || '[]'); 
        }  
    }  
}  
</script>  

<style scoped>  

</style>  